var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPyAlt3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_70)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 175.5,
    r: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 24.5,
    r: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.825 200C91.1838 199.991 83.5569 199.338 76.025 198.05C55.825 194.475 52.175 187.025 52.175 173.25V155H100V149H34.25C20.4 149 8.25005 140.675 4.45005 124.825C4.92334e-05 106.65 4.92334e-05 95.3 4.45005 76.325C7.85005 62.2 15.95 52.125 29.8 52.125H46.225V73.925C46.3983 81.7601 49.5982 89.2239 55.1538 94.7515C60.7094 100.279 68.1892 103.441 76.025 103.575H123.675C126.832 103.601 129.953 104.249 132.86 105.483C135.766 106.716 138.401 108.51 140.614 110.762C142.827 113.014 144.574 115.68 145.755 118.608C146.937 121.536 147.53 124.668 147.5 127.825V173.25C147.5 186.175 136.6 195.9 123.65 198.05C115.444 199.391 107.14 200.044 98.825 200ZM73.025 185.375C74.8299 185.405 76.6028 184.897 78.1183 183.917C79.6338 182.936 80.8235 181.527 81.536 179.868C82.2486 178.21 82.4517 176.377 82.1198 174.603C81.7878 172.828 80.9356 171.193 79.6717 169.904C78.4077 168.616 76.789 167.732 75.0215 167.366C73.254 166.999 71.4174 167.167 69.7455 167.847C68.0735 168.528 66.6416 169.69 65.6319 171.186C64.6222 172.682 64.0802 174.445 64.075 176.25C64.055 178.646 64.986 180.952 66.6637 182.663C68.3415 184.373 70.6292 185.349 73.025 185.375Z",
    fill: "url(#paint0_linear_9_70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.475 149V127.825C153.406 119.894 150.261 112.299 144.702 106.642C139.143 100.985 131.604 97.7071 123.675 97.5H76.0251C69.6713 97.3696 63.6204 94.7603 59.1642 90.2294C54.7081 85.6985 52.1998 79.605 52.175 73.25V27.875C52.175 14.95 63.4 7.35002 76.0251 3.65001C91.5365 -1.21074 108.164 -1.21074 123.675 3.65001C135.7 7.12502 147.5 14.125 147.5 27.875V46.075H100V52.125H171.4C185.25 52.125 190.425 61.8 195.25 76.325C200.25 91.325 200.025 105.65 195.25 124.825C191.825 138.625 185.25 149 171.4 149H153.475ZM126.675 34C128.482 34.0298 130.257 33.5209 131.774 32.5381C133.29 31.5554 134.48 30.1433 135.191 28.4819C135.902 26.8204 136.102 24.9849 135.766 23.2092C135.43 21.4335 134.573 19.7981 133.304 18.5114C132.035 17.2246 130.412 16.3449 128.641 15.9843C126.87 15.6236 125.032 15.7984 123.361 16.4864C121.69 17.1744 120.261 18.3444 119.258 19.8473C118.254 21.3501 117.72 23.1178 117.725 24.925C117.718 27.3077 118.657 29.5957 120.335 31.2875C122.012 32.9793 124.292 33.9368 126.675 33.95V34Z",
    fill: "url(#paint1_linear_9_70)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_70",
    x1: -4.61795,
    y1: 193.121,
    x2: 105.653,
    y2: 99.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9FD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_70",
    x1: 146.022,
    y1: 40.4038,
    x2: 106.307,
    y2: 95.6011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD43B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 200)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyAlt3);
export default __webpack_public_path__ + "static/media/py-alt3.ee84ea7dc55f4ecd03af0c751356d7f2.svg";
export { ForwardRef as ReactComponent };